import {RouterProps} from "../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {UserWithdrawalValueObject} from "../../../data/value-object/user/UserWithdrawalValueObject";
import {useEffect} from "react";
import {UserWithdrawalIO} from "../../../io/UserIO";
import {Body1, Caption1Strong, Spinner, Tab, TabList} from "@fluentui/react-components";
import {UserWithdrawalDomain} from "../../../data/domain/user/UserWithdrawalDomain";
import {UserWithdrawalDescriptor} from "../../../data/descriptor/user/UserWithdrawalDescriptor";
import {mapByKey} from "../../../util/ObjectUtil";
import {UserWithdrawalDescription} from "../../../data/description/user/UserWithdrawalDescription";

enum Panel {
    Default,
}

export default function Detail(props: RouterProps) {
    const params = useParams<{ userWithdrawalId: string }>()
    const item = useStatePair<UserWithdrawalValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.userWithdrawalId !== undefined) {
            UserWithdrawalIO
                .getById(BigInt(params.userWithdrawalId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: UserWithdrawalValueObject
}

function Page(props: PageProps) {
    const panel = useStatePair<Panel>(Panel.Default)
    return <>
        <div className={props.styles.row16}>
            <TabList
                selectedValue={panel.value}
                onTabSelect={(_, data) => panel.setter(data.value as Panel)}
                vertical>
                <Tab value={Panel.Default}>상세</Tab>
            </TabList>
            <DefaultPanel
                {...props}
                panel={panel.value} />
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof UserWithdrawalDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "createdAt":
            return <Body1>{UserWithdrawalDescriptor[props.itemKey](props.item)}</Body1>
        case "userId":
            return props.item.userId !== undefined
                ? <a href={`/users/${props.item.userId}`}><Body1>{UserWithdrawalDescriptor[props.itemKey](props.item)}</Body1></a>
                : <Body1>-</Body1>
        case "userWithdrawalReasonId":
            return props.item.userId !== undefined
                ? <a href={`/users/withdrawals/reasons/${props.item.userWithdrawalReasonId}`}><Body1>{UserWithdrawalDescriptor[props.itemKey](props.item)}</Body1></a>
                : <Body1>-</Body1>
    }
}

export function UserWithdrawalPropertyBody(props: PropertyBodyProps) {
    return <PropertyBody {...props} />
}

type PanelProps = PageProps & {
    panel: Panel
    children?: false | JSX.Element | JSX.Element[]
}

function DefaultPanel(props: PanelProps) {
    return <>
        {props.panel === Panel.Default && <>
            <div className={props.styles.column16}>
                {mapByKey(UserWithdrawalDescription, key => <>
                    <div className={props.styles.column4}>
                        <Caption1Strong>{UserWithdrawalDescription[key]}</Caption1Strong>
                        <PropertyBody
                            {...props}
                            itemKey={key}/>
                    </div>
                </>)}
                {props.children}
            </div>
        </>}
    </>
}